import React from 'react';
import { useTranslation } from 'react-i18next';
import ScatterWithAreaChart from '../../../components/charts/ScatterWithAreaChart';
import { useWindowSize } from '../../../hooks/windowSize';
import { IGetMttrVsFailsChartData } from '../../../types/kpis';

interface IFailureAnalysis {
  data: IGetMttrVsFailsChartData;
  height?: string | number;
}

const FailureAnalysis: React.FC<IFailureAnalysis> = ({ data, height }) => {
  const { t } = useTranslation();
  const size = useWindowSize();

  return (
    <ScatterWithAreaChart
      title={t('screens:availability.failureAnalysis')}
      xaxisTitle={t('screens:availability.numberOfFailures')}
      yaxisTitle="MTTR"
      data={data}
      showLegend={false}
      width={size.width ? size.width * 0.23 : '100%'}
      height={height}
    />
  );
};

export default FailureAnalysis;
